import { useMemo, useState } from 'react'
import { useHostUsage } from '@/api/queries'
import { StackedBars } from '@/components/charts/StackedBars'
import { EmptyState, ErrorState } from '@/components/ui/EmptyState'
import { Widget } from '@/components/ui/Widget'
import { compactNumber, stripWww } from '@/lib/format'
import { SiteUsageDialog } from './SiteUsageDialog'

const MAX_BARS = 12

/** Success/error share of today's proxy traffic for the busiest hosts. */
export function SiteUsageWidget({ className }: { className?: string }) {
  const { data, isLoading, error } = useHostUsage()
  const [open, setOpen] = useState(false)

  const bars = useMemo(
    () =>
      [...(data ?? [])]
        .sort((a, b) => b.numberOfRequests - a.numberOfRequests)
        .slice(0, MAX_BARS)
        .map((h) => ({
          name: stripWww(h.host),
          success: h.numberOfRequests ? (h.numberOfSuccess / h.numberOfRequests) * 100 : 0,
          errors: h.numberOfRequests ? (h.numberOfErrors / h.numberOfRequests) * 100 : 0,
          requests: h.numberOfRequests,
        })),
    [data],
  )
  const total = data?.reduce((sum, h) => sum + h.numberOfRequests, 0)

  return (
    <Widget
      title="Sites usage · today"
      onTitleClick={() => setOpen(true)}
      loading={isLoading}
      className={className}
      actions={data && <span className="u-muted">{compactNumber(total)} requests</span>}
    >
      {error ? <ErrorState error={error} /> : data && bars.length === 0 ? <EmptyState>No proxy traffic recorded today</EmptyState> : <StackedBars data={bars} onClick={() => setOpen(true)} />}
      {open && <SiteUsageDialog onClose={() => setOpen(false)} />}
    </Widget>
  )
}
